import { IReservationInformationDetail } from 'pages/reservationDetail/type';
import reducer from './reducer';
import * as ReservationActions from './actions';

export interface ReservationBookingOnlineType {
detailBooking: ReservationActions.FinishBookingData | null;
dataFormSubmit: ReservationActions.IFormDataSubmitData | null;
}

export {
  ReservationActions,
};

export default reducer;
